import React from "react"

const Phone = () => (
	<svg width="14" height="18" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12.993 0A1 1 0 0 1 14 .993v16.014a1 1 0 0 1-1.007.993H1.007A1 1 0 0 1 0 17.007V.993A1 1 0 0 1 1.007 0ZM7 15l-.117.007A1 1 0 0 0 6 16l.007.117A1 1 0 0 0 7 17l.117-.007A1 1 0 0 0 8 16l-.007-.117A1 1 0 0 0 7 15Zm5-13H2v12h10V2Z"
			fill="#3776A5"
		/>
	</svg>
)

export default Phone
